module.exports = __webpack_public_path__ + "static/media/roster--tablet-input.0056c1cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/rostery/src/roster--tablet-input.png
// module id = 633
// module chunks = 0